<script>
    export default {
        props: {
            data: Object
        },
        data() {
            return {
                item: this.data,
                form: {
                    qty: 1
                }
            }
        },
        created() {
            this.$bus.$on('reset-card', this.reset)
        },
        methods: {
            onSubmit() {
                this.$bus.$emit('update-item', Object.assign(this.item, this.form))
            },
            reset() {
                this.$set(this.form, 'qty', 1)
            },
            initializeQuantity(item) {
                this.$set(this.form, 'qty', 1)
            }
        },
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/gift/GiftCardItem.vue